import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ColumnDirective, ColumnsDirective,
    GridComponent, Grid, Inject, Page, Sort, Filter, Resize,
    Toolbar, ExcelExport, PdfExport, ColumnChooser
} from '@syncfusion/ej2-react-grids';
import { Aggregate, Group, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, AggregatesDirective } from '@syncfusion/ej2-react-grids';
import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "./../../../store/actions/uiAction";
import { logReportService } from "./../../../services/logReportService";
import ComboHotelSala from "./../../../components/combo-hotel-sala/combo-hotel-sala";
import ComboUsuariosSala from "./../../../components/combo-usuarios/combo-usuarios";
import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';
import './SalesRoomStats.scss';

const SalesRoomStats = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel } = useSelector(state => state.user.param);
    const [puestosData, setPuestosData] = useState([]);
    const [colaboradoresData, setColaboradoresData] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [NamePuesto, setNamePuesto] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);
    const [eficienciaColaborador, setEficienciaColaborador] = useState(false);
    const toolbarOptions = ['ColumnChooser', 'ExcelExport'];

    let grid = null;

    let mulObjPuestos = [];
    let mulObjColaboradores = [];
    let mulObjProgramas = null;

    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const checkFields = { text: 'Name', value: 'Code' };

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleViewButton = () => {
        getManifestReport();
    }

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, eject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }

                    resolve(res);
                }
            })
        })

    }
    const getPuestosData = () => {
        getOptionData('/catalog/puestos')
            .then((response) => {
                setPuestosData(response);
            })
    }

    const getColaboradoresData = () => {
        getOptionData('/catalog/colaboradores')
            .then((response) => {
                setColaboradoresData(response);
            })
    }

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            })
    }

    const getManifestReport = () => {

        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');

        const puestos = (mulObjPuestos != null && mulObjPuestos.value.length > 0) ? mulObjPuestos.value.map(String).toString() : "0";
        const idColaborador = (mulObjColaboradores != null && mulObjColaboradores.value.length > 0) ? mulObjColaboradores.value.map(String).toString() : "0";
          const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        getDataReport(`/catalog/getNamePuestoId/${puestos}`).then((response) => {
            if (response.status === 200) {
                setNamePuesto(response.data);
            }
        })

           getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                console.log(response.data);
                
                setNamePrograma(response.data);
            }
        })
        getDataReport(`/reports/sales-room-statics/${date1}/${date2}/${idSaleRoom}/${idHotel}/${puestos}/${idColaborador}/${programas}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('Sales room statistic', user);
            }
        })
    }

    // Reporte
    const handleButtonOption = (opt) => {
        if (grid && opt.target.innerText === 'Export to excel') {
            export2Excel();
        } else {
            if (grid && opt.target.innerText === 'Export to pdf') {
                grid.pdfExport();
            }
        }
    }

    const export2Excel = () => {
        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();
        const excelExportProperties = {
            fileName: t('menusidebar.label.sales-room-statistics') + ".xlsx",
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 },
            },
            header: {
                headerRows: 8,
                rows: [
                    { cells: [{ colSpan: 4, value: "LVC KCS", style: { fontColor: '#000000', fontSize: 20, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: t('menusidebar.label.sales-room-statistics'), style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "SALES ROOM: " + NameSala["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "HOTELS: " + NameHotel["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "JOBS: " + NamePuesto[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "PROGRAMS: " + NamePrograma[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: date1 + " - " + date2, style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true, } }] },

                ]
            }
        }
        grid.excelExport(excelExportProperties);
    }

    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    }

    const exportExcelEfficiencyFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const puestos = (mulObjPuestos != null && mulObjPuestos.value.length > 0) ? mulObjPuestos.value.map(String).toString() : "0";
        const idColaborador = (mulObjColaboradores != null && mulObjColaboradores.value.length > 0) ? mulObjColaboradores.value.map(String).toString() : "0";
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        var download_excel_url = `${base_url}/reports/sales-room-statics-xls/${date1}/${date2}/${idSaleRoom}/${idHotel}/${puestos}/${idColaborador}/${programas}`;
        //console.log(download_excel_url);
        window.open(download_excel_url, '_parent');
    }

       const exportExcelEfficiencyFullFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const puestos = (mulObjPuestos != null && mulObjPuestos.value.length > 0) ? mulObjPuestos.value.map(String).toString() : "0";
        const idColaborador = (mulObjColaboradores != null && mulObjColaboradores.value.length > 0) ? mulObjColaboradores.value.map(String).toString() : "0";
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        var download_excel_url = `${base_url}/reports/sales-room-statics-xls-full/${date1}/${date2}/${idSaleRoom}/${idHotel}/${puestos}/${idColaborador}/${programas}`;
        //console.log(download_excel_url);
        window.open(download_excel_url, '_parent');
    }


    const groupOptions = {
        columns: ['puesto'],
        showDropArea: false
    };

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else if (grid && args.item.id === 'grid_pdfexport') {
            grid.pdfExport();
        } else if (grid && args.item.text === 'Column Chooser') {
            grid.columnChooserModule.openColumnChooser();
        }
    }

    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    }
    function footerSum(props) {
        return (<span>{props.Sum}</span>);

    }

    const footerArrivalSum = (props) => {
        return (<span>{props.Sum}</span>);
    }

    const footeAvailsSum = (props) => {
        return (<span>{props.Sum}</span>);
    }

    function footerAverage(props) {
        return (<span>{props.Average}</span>);
    }

    function custom(props) {
        return (<span>{props.Custom}</span>);
    }




    function customAggregateFnCl(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['cancelled'];
            totalSum2 = totalSum2 + data[i]['totalSales'];
        }

        let average = 0;
        totalSum2 == 0 ? average = totalSum2 : average = totalSum1 / totalSum2;
        // return the calculated value

        return average;

    }

    function customAggregateFnEff(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['totalVolume'];
            totalSum2 = totalSum2 + data[i]['sh'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }

    function customAggregateFnEffQs(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volumenqs'];
            totalSum2 = totalSum2 + data[i]['qs'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }

    function customAggregateFnEffNQs(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volnqs'];
            totalSum2 = totalSum2 + data[i]['nqs'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }

    function customAggregateFnEffCts(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volumencts'];
            totalSum2 = totalSum2 + data[i]['ct'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }

    function customAggregateFnEffAnual(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['yearsalesamount'];
            totalSum2 = totalSum2 + data[i]['yearsh'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }


    function customAggregateFnClo(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['totalSales'];
            totalSum2 = totalSum2 + data[i]['sh'];
        }

        let closingPercent = 0;

        totalSum2 == 0 ? closingPercent = 0 : closingPercent = totalSum1 / totalSum2;

        // return the calculated value

        return closingPercent;

    }

    function customAggregateFnCloqs(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        let totalsalesqs = 0;
        let totalqs = 0;

        for (let i = 0; i < data.length; i++) {
            totalsalesqs += Number(data[i].salesqs) || 0;
            totalqs += Number(data[i].qs) || 0;
        }
        // Manejar división por cero y formato decimal
        return totalqs === 0 ? 0 : (totalsalesqs / totalqs);
        // return the calculated value
    }

    function customAggregateFnClonqs(args) {

        const data = args.data; // ✅ Usa args.data
        if (!data || !Array.isArray(data) || data.length === 0) return 0;

        let totalSum1 = 0;
        let totalSum2 = 0;

        for (let i = 0; i < data.length; i++) {
            totalSum1 += data[i].salesnqs;
            totalSum2 += data[i].nqs;
        }

        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;

    }

    function customAggregateFnClocts(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['salesqs'];
            totalSum2 = totalSum2 + data[i]['qs'];
        }

        let closingPercent = 0;

        totalSum2 == 0 ? closingPercent = 0 : closingPercent = totalSum1 / totalSum2;

        // return the calculated value

        return closingPercent;

    }

    function customAggregateFnCloAnual(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['yearsales'];
            totalSum2 = totalSum2 + data[i]['yearsh'];
        }

        let closingPercent = 0;

        totalSum2 == 0 ? closingPercent = 0 : closingPercent = totalSum1 / totalSum2;

        // return the calculated value

        return closingPercent;

    }

    function customAggregateFnAvg(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['totalVolume'];
            totalSum2 = totalSum2 + data[i]['totalSales'];
        }

        let avg = 0;

        totalSum2 == 0 ? avg = 0 : avg = totalSum1 / totalSum2;

        // return the calculated value
        return avg;

    }


    function customAggregateFnAvgqs(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volumenqs'];
            totalSum2 = totalSum2 + data[i]['salesqs'];
        }

        let avg = 0;

        totalSum2 == 0 ? avg = 0 : avg = totalSum1 / totalSum2;

        // return the calculated value
        return avg;

    }


    function customAggregateFnAvgnqs(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volnqs'];
            totalSum2 = totalSum2 + data[i]['salesnqs'];
        }

        let avg = 0;

        totalSum2 == 0 ? avg = 0 : avg = totalSum1 / totalSum2;

        // return the calculated value
        return avg;

    }


    function customAggregateFnAvgCts(args) {

        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) {
            return 0;
        }
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < data.length; i++) {
            totalSum1 = totalSum1 + data[i]['volumencts'];
            totalSum2 = totalSum2 + data[i]['salescts'];
        }

        let avg = 0;

        totalSum2 == 0 ? avg = 0 : avg = totalSum1 / totalSum2;

        // return the calculated value
        return avg;

    }

    function customAggregateFnClonqes(args) {
        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) return 0;
        let totalSum1 = 0;
        let totalSum2 = 0;
        for (let i = 0; i < data.length; i++) {
            totalSum1 += data[i].salesnqes;
            totalSum2 += data[i].nqes;
        }
        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnEffNQes(args) {
        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) return 0;
        let totalSum1 = 0;
        let totalSum2 = 0;
        for (let i = 0; i < data.length; i++) {
            totalSum1 += data[i].volnqes;
            totalSum2 += data[i].nqes;
        }
        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }

    function customAggregateFnAvgnqes(args) {
        const data = args.data;
        if (!data || !Array.isArray(data) || data.length === 0) return 0;
        let totalSum1 = 0;
        let totalSum2 = 0;
        for (let i = 0; i < data.length; i++) {
            totalSum1 += data[i].volnqes;
            totalSum2 += data[i].salesnqes;
        }
        return totalSum2 === 0 ? 0 : totalSum1 / totalSum2;
    }
    // Fin Reporte

    useEffect(() => {
        getPuestosData();
        getColaboradoresData();
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.sales-room-statistics')));
    }, []);

    return (

        <div className="container-fluid">
            {/* Hotel and Sala Combo */}
            <div className="row mb-3">
                <div className="col-12">
                    <ComboHotelSala />
                </div>
            </div>
            
            {/* Filters Section */}
            <div className="row">
                {/* Date Start */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Date start:</label>
                    <SemanticDatepicker name="dateStart" value={dateStart} onChange={onChangeDateStart} />
                </div>
                
                {/* Date End */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Date end:</label>
                    <SemanticDatepicker name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />
                </div>
                
                {/* Colaboradores */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Colaboradores:</label>
                    <MultiSelectComponent 
                        id="colaboradores" 
                        ref={(scope) => { mulObjColaboradores = scope; }} 
                        dataSource={colaboradoresData}
                        fields={checkFields} 
                        placeholder="Seleccionar colaboradores" 
                        mode="CheckBox" 
                        showSelectAll={true} 
                        value={[]}
                        showDropDownIcon={true} 
                        allowFiltering={true} 
                        filterBarPlaceholder="Buscar colaborador" 
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                
                {/* Jobs */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Jobs:</label>
                    <MultiSelectComponent 
                        id="checkbox" 
                        ref={(scope) => { mulObjPuestos = scope; }} 
                        dataSource={puestosData}
                        fields={checkFields} 
                        placeholder="Select estatus" 
                        mode="CheckBox" 
                        showSelectAll={true} 
                        value={[]}
                        showDropDownIcon={true} 
                        filterBarPlaceholder="Search estatus" 
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>

                {/* Programas */}
                <div className="col-12 col-sm-6 col-md-3 form-group mb-3">
                    <label>Programas:</label>
                    <MultiSelectComponent
                        id="Programa"
                        ref={(scope) => { mulObjProgramas = scope; }}
                        dataSource={programasData}
                        fields={checkFields}
                        placeholder="Seleccionar programas"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        filterBarPlaceholder="Buscar programa"
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                

                
                {/* Buttons Section */}
                <div className="col-12 col-md-9 mb-3">
                    <div className="d-flex flex-wrap gap-2">
                        <Button 
                            primary 
                            onClick={handleViewButton}
                            className="mb-2 mb-sm-0"
                        >
                            View Report
                        </Button>
                        <Button 
                            positive 
                            onClick={exportExcelEfficiencyFullFromAPI}
                            className="mb-2 mb-sm-0"
                        >
                            Export Report Full
                        </Button>
                        <Button 
                            positive 
                            onClick={exportExcelEfficiencyFromAPI}
                            className="mb-2 mb-sm-0"
                        >
                            Export sales room efficiency
                        </Button>
                    </div>
                </div>
            </div>
            
            {/* Grid Section */}
            <div className="row">
                <div className="col-12">
                    <div className="grid-container">
                        <GridComponent 
                            id="grid" 
                            dataSource={rowData}
                            allowSorting={true}
                            allowResizing={true}
                            allowExcelExport={true}
                            allowPdfExport={false}
                            groupSettings={groupOptions}
                            allowGrouping={true}
                            toolbar={toolbarOptions}
                            showColumnChooser={true}
                            toolbarClick={handleToolbarClick}
                            dataBound={dataBound}
                            ref={g => grid = g}
                            height={600}
                            width='100%'
                            rowHeight={38}
                            gridLines='Both'
                        >
                    <Inject services={[Sort, Toolbar, Resize, ExcelExport, PdfExport, Aggregate, Group, ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='prId' headerText="Id" width='80' minWidth='50' textAlign="Right"  />
                        <ColumnDirective field='prName' headerText="Nombre" width='150' minWidth='120' textAlign="Left"  />
                        <ColumnDirective field='puesto' headerText="Puesto" width='150' minWidth='100' visible={false} textAlign="Left"/>
                        <ColumnDirective field='qs' headerText="Qs" width='100' minWidth='80' textAlign="Right" format="N2" />
                        <ColumnDirective field='salesqs' headerText="Ventas Qs" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volumenqs' headerText="Volumen Qs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercentqs' headerText="%CI Qs" width='100' minWidth='90' textAlign="Right" format="P2" />
                        <ColumnDirective field='effqs' headerText="Eficiencia Qs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgqs' headerText="Vta. Promedio Qs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='q1s' headerText="Q1s" width='100' minWidth='80' textAlign="Right" format="N2" />
                        <ColumnDirective field='salesq1s' headerText="Ventas Q1s" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volumenq1s' headerText="Volumen Q1s" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='closingPercentq1s' headerText="%CI Q1s" width='100' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='effq1s' headerText="Eficiencia Q1s" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='avgq1s' headerText="Vta. Promedio Q1s" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='qfs' headerText="QFs" width='100' minWidth='80' textAlign="Right" format="N2" />
                        <ColumnDirective field='salesqfs' headerText="Ventas QFs" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volumenqfs' headerText="Volumen QFs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercentqfs' headerText="%CI QFs" width='100' minWidth='90' textAlign="Right" format="P2" />
                        <ColumnDirective field='effqfs' headerText="Eficiencia QFs" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='avgqfs' headerText="Vta. Promedio QFs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='nqs' headerText="NQs" width='100' minWidth='80' textAlign="Right" format="N2" />
                        <ColumnDirective field='salesnqs' headerText="Ventas NQs" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volnqs' headerText="Volumen NQs" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='closingPercentnqs' headerText="%CI NQs" width='100' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='effnqs' headerText="Eficiencia NQs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='avgnqs' headerText="Vta. Promedio NQs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='nqfs' headerText="NQFs" width='100' minWidth='80' textAlign="Right" format="N2"  />
                        <ColumnDirective field='salesnqfs' headerText="Ventas NQFs" width='120' minWidth='100' textAlign="Right" format="N2" />
                        <ColumnDirective field='volumennqfs' headerText="Volumen NQFs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercentnqfs' headerText="%CI NQFs" width='100' minWidth='90' textAlign="Right" format="P2" />
                        <ColumnDirective field='effnqfs' headerText="Eficiencia NQFs" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='avgnqfs' headerText="Vta. Promedio NQFs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='nqes' headerText="NQEs" width='100' minWidth='80' textAlign="Right" format="N2"  />
                        <ColumnDirective field='salesnqes' headerText="Ventas NQEs" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volnqes' headerText="Volumen NQEs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercentnqes' headerText="%CI NQEs" width='100' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='effnqes' headerText="Eficiencia NQEs" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='avgnqes' headerText="Vta. Promedio NQEs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='ct' headerText="CTs" width='100' minWidth='80' textAlign="Right" format="N2"  />
                        <ColumnDirective field='salescts' headerText="Ventas CTs" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='volumencts' headerText="Volumen CTs" width='130' minWidth='110' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercentcts' headerText="%CI CTs" width='100' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='effcts' headerText="Eficiencia CTs" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='avgcts' headerText="Vta. Promedio CTs" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='sh' headerText="T. shows" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='wo' headerText="W/o" width='100' minWidth='80' textAlign="Right" format="N2"  />
                        <ColumnDirective field='sales' headerText="Ventas" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='processable' headerText="Processable" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='oop' headerText="OOP" width='100' minWidth='80' textAlign="Right" format="N2"  />
                        <ColumnDirective field='oopVolume' headerText="Volumen OOP" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='cancelled' headerText="Cancelados" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='cancelledVolume' headerText="Volumen Cancelados" width='160' minWidth='140' textAlign="Right" format="C2"  />
                        <ColumnDirective field='cancelPercent' headerText="%Cancelados" width='130' minWidth='110' textAlign="Right" format="P2"  />
                        <ColumnDirective field='totalSales' headerText="Ventas totales" width='130' minWidth='110' textAlign="Right" format="N2" />
                        <ColumnDirective field='totalVolume' headerText="Volumen total" width='130' minWidth='110' textAlign="Right" format="C2"  />
                        <ColumnDirective field='eff' headerText="Eficencia" width='120' minWidth='100' textAlign="Right" format="C2"  />
                        <ColumnDirective field='closingPercent' headerText="%Cierre" width='110' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='avg' headerText="Venta promedio" width='140' minWidth='120' textAlign="Right" format="C2"  />
                        <ColumnDirective field='pending' headerText="Pendientes" width='120' minWidth='100' textAlign="Right" format="N2"  />
                        <ColumnDirective field='pendingVolume' headerText="Volumen Pendiente" width='150' minWidth='130' textAlign="Right" format="C2"  />
                        <ColumnDirective field='closingcost' headerText="CC" width='100' minWidth='80' textAlign="Right" format="C2"  />
                        <ColumnDirective field='volumentotal' headerText="% Volumen" width='120' minWidth='100' textAlign="Right" format="P2"  />
                        <ColumnDirective field='shatendidas' headerText="% Sh" width='100' minWidth='80' textAlign="Right" format="P2"  />
                        <ColumnDirective field='qsatendidas' headerText="% Qs" width='100' minWidth='80' textAlign="Right" format="P2"  />
                        <ColumnDirective field='eficienciatotal' headerText="% VPG" width='110' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='yearqs' headerText="YearQs" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='YearQ1s' headerText="YearQ1s" width='110' minWidth='90' textAlign="Right" format="N2" />
                        <ColumnDirective field='yearqfs' headerText="YearQfs" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearnqs' headerText="YearNQs" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearnqfs' headerText="YearNQFs" width='110' minWidth='90' textAlign="Right" format="N2" />
                        <ColumnDirective field='yearcts' headerText="YearCTs" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearsh' headerText="Yearsh" width='110' minWidth='90' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearsales' headerText="YearSales" width='120' minWidth='100' textAlign="Right" format="N2" />
                        <ColumnDirective field='yearsalesamount' headerText="YearTotalAmount" width='160' minWidth='140' textAlign="Right" format="C2"  />
                        <ColumnDirective field='yearclanual' headerText="Year %CI" width='110' minWidth='90' textAlign="Right" format="P2"  />
                        <ColumnDirective field='yeareffanual' headerText="YearEffAnual" width='140' minWidth='120' textAlign="Right" format="C2"  />
                        <ColumnDirective field='yearsalespender' headerText="YearPendSales" width='140' minWidth='120' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearsalespenderamount' headerText="YearPendAmount" width='160' minWidth='140' textAlign="Right" format="C2"  />
                        <ColumnDirective field='yearallsalespender' headerText="AllPendSales" width='140' minWidth='120' textAlign="Right" format="N2"  />
                        <ColumnDirective field='yearallSalespenderamount' headerText="AllPendAmount" width='160' minWidth='140' textAlign="Right" format="C2"  />
                    </ColumnsDirective>
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                <AggregateColumnDirective field='qs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='q1s' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='qfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='nqs' type='Sum' customAggregate={footeAvailsSum} />
                               <AggregateColumnDirective field='nqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='ct' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='sh' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='wo' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='sales' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='processable' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='oop' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='oopVolume' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelled' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelledVolume' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='cancelPercent' type='Custom' format='P2' customAggregate={customAggregateFnCl} />
                                <AggregateColumnDirective field='totalSales' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='totalVolume' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='eff' type='Custom' format="C2" customAggregate={customAggregateFnEff} />
                                <AggregateColumnDirective field='closingPercent' type='Custom' format='P2' customAggregate={customAggregateFnClo} />
                                <AggregateColumnDirective field='avg' type='Custom' format="C2" customAggregate={customAggregateFnAvg} />
                                <AggregateColumnDirective field='salesqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salesq1s' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salesqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salesnqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salesnqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salescts' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumenqs' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumenq1s' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                 <AggregateColumnDirective field='volumenqfs' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volnqs' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                  <AggregateColumnDirective field='volumennqfs' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volumencts' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingPercentqs' type='Custom' format='P2' customAggregate={customAggregateFnCloqs} groupCaptionTemplate="${Custom}" />
                                <AggregateColumnDirective field='closingPercentnqs' type='Custom' format='P2' customAggregate={customAggregateFnClonqs} />
                                <AggregateColumnDirective field='closingPercentcts' type='Custom' format='P2' customAggregate={customAggregateFnClocts} />
                                <AggregateColumnDirective field='effqs' type='Custom' format="C2" customAggregate={customAggregateFnEffQs} />
                                <AggregateColumnDirective field='effq1s' type='Custom' format="C2" customAggregate={customAggregateFnEffQs} />
                                <AggregateColumnDirective field='effqfs' type='Custom' format="C2" customAggregate={customAggregateFnEffQs} />
                                <AggregateColumnDirective field='effnqs' type='Custom' format="C2" customAggregate={customAggregateFnEffNQs} />
                                <AggregateColumnDirective field='effnqfs' type='Custom' format="C2" customAggregate={customAggregateFnEffNQs} />
                                <AggregateColumnDirective field='effcts' type='Custom' format="C2" customAggregate={customAggregateFnEffCts} />
                                <AggregateColumnDirective field='avgqs' type='Custom' format="C2" customAggregate={customAggregateFnAvgqs} />
                                <AggregateColumnDirective field='avgq1s' type='Custom' format="C2" customAggregate={customAggregateFnAvgqs} />
                                <AggregateColumnDirective field='avgqfs' type='Custom' format="C2" customAggregate={customAggregateFnAvgqs} />
                                <AggregateColumnDirective field='avgnqs' type='Custom' format="C2" customAggregate={customAggregateFnAvgnqs} />
                                <AggregateColumnDirective field='avgnqfs' type='Custom' format="C2" customAggregate={customAggregateFnAvgnqs} />
                                <AggregateColumnDirective field='nqes' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='salesnqes' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='volnqes' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='closingPercentnqes' type='Custom' format='P2' customAggregate={customAggregateFnClonqes} />
                                <AggregateColumnDirective field='effnqes' type='Custom' format="C2" customAggregate={customAggregateFnEffNQes} />
                                <AggregateColumnDirective field='avgnqes' type='Custom' format="C2" customAggregate={customAggregateFnAvgnqes} />
                                <AggregateColumnDirective field='avgcts' type='Custom' format="C2" customAggregate={customAggregateFnAvgCts} />
                                <AggregateColumnDirective field='pending' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='pendingVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='closingcost' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='volumentotal' type='Sum' format='P2' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='shatendidas' type='Sum' format='P2' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='qsatendidas' type='Sum' format='P2' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearq1s' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearnqs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearnqfs' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearcts' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearsh' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearsales' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearsalesamount' format="C2" type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearclanual' type='Custom' format='P2' customAggregate={customAggregateFnCloAnual} />
                                <AggregateColumnDirective field='yeareffanual' type='Custom' format="C2" customAggregate={customAggregateFnEffAnual} />
                                <AggregateColumnDirective field='yearsalespender' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearsalespenderamount' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearallsalespender' type='Sum' customAggregate={footeAvailsSum} />
                                <AggregateColumnDirective field='yearallSalespenderamount' type='Sum' format="C2" customAggregate={footeAvailsSum} />
                            </AggregateColumnsDirective>
                        </AggregateDirective>

                    </AggregatesDirective>
                </GridComponent>
                    </div>
                </div>
            </div>
        </div>
    );


}

export default SalesRoomStats;
